/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSource } from '../models/data-source';
import { DataSourcePartial } from '../models/data-source-partial';
import { DataSourceWithRelations } from '../models/data-source-with-relations';
import { IngestDataSourceRequestDto } from '../models/ingest-data-source-request-dto';
import { NewDataSource } from '../models/new-data-source';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class DataSourceControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dataSourceControllerCount
   */
  static readonly DataSourceControllerCountPath = '/data-sources/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataSourceControllerIngest
   */
  static readonly DataSourceControllerIngestPath = '/data-sources/ingest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ingest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ingest$Response(params?: {
    body?: IngestDataSourceRequestDto
  }): Observable<StrictHttpResponse<DataSource>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerIngestPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSource>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ingest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ingest(params?: {
    body?: IngestDataSourceRequestDto
  }): Observable<DataSource> {

    return this.ingest$Response(params).pipe(
      map((r: StrictHttpResponse<DataSource>) => r.body as DataSource)
    );
  }

  /**
   * Path part for operation dataSourceControllerIngestV2
   */
  static readonly DataSourceControllerIngestV2Path = '/data-sources/ingest-v2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ingestV2()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ingestV2$Response(params: {

    /**
     * multipart/form-data value.
     */
    body: { 'id'?: string, 'name'?: string, 'connector'?: 'mongodb' | 'mssql' | 'postgresql' | 'mysql' | 'file' | 'salesforce' | 'curl' | 'file-storage', 'title'?: string, 'description'?: string, 'ingestionConfig'?: { 'ingestionAllFields'?: boolean, 'ingestionFieldsArray'?: Array<string> }, 'dataForCreate'?: string, 'config'?: { [key: string]: any }, 'ingestionMetadata'?: { [key: string]: any }, 'isApproved'?: boolean }
  }): Observable<StrictHttpResponse<DataSource>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerIngestV2Path, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSource>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ingestV2$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  ingestV2(params: {

    /**
     * multipart/form-data value.
     */
    body: { 'id'?: string, 'name'?: string, 'connector'?: 'mongodb' | 'mssql' | 'postgresql' | 'mysql' | 'file' | 'salesforce' | 'curl' | 'file-storage', 'title'?: string, 'description'?: string, 'ingestionConfig'?: { 'ingestionAllFields'?: boolean, 'ingestionFieldsArray'?: Array<string> }, 'dataForCreate'?: string, 'config'?: { [key: string]: any }, 'ingestionMetadata'?: { [key: string]: any }, 'isApproved'?: boolean }
  }): Observable<DataSource> {

    return this.ingestV2$Response(params).pipe(
      map((r: StrictHttpResponse<DataSource>) => r.body as DataSource)
    );
  }

  /**
   * Path part for operation dataSourceControllerRetrieveIngestionLog
   */
  static readonly DataSourceControllerRetrieveIngestionLogPath = '/data-sources/{id}/ingestion-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveIngestionLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveIngestionLog$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerRetrieveIngestionLogPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `retrieveIngestionLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveIngestionLog(params: {
    id: string;
  }): Observable<any> {

    return this.retrieveIngestionLog$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataSourceControllerReset
   */
  static readonly DataSourceControllerResetPath = '/data-sources/{id}/reset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reset()` instead.
   *
   * This method doesn't expect any request body.
   */
  reset$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerResetPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reset(params: {
    id: string;
  }): Observable<any> {

    return this.reset$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataSourceControllerSyncDriveFolders
   */
  static readonly DataSourceControllerSyncDriveFoldersPath = '/data-sources/{id}/sync-files';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncDriveFolders()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncDriveFolders$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerSyncDriveFoldersPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `syncDriveFolders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncDriveFolders(params: {
    id: string;
  }): Observable<any> {

    return this.syncDriveFolders$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataSourceControllerFindById
   */
  static readonly DataSourceControllerFindByIdPath = '/data-sources/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<DataSourceWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSourceWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<DataSourceWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataSourceWithRelations>) => r.body as DataSourceWithRelations)
    );
  }

  /**
   * Path part for operation dataSourceControllerDeleteById
   */
  static readonly DataSourceControllerDeleteByIdPath = '/data-sources/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataSourceControllerUpdateById
   */
  static readonly DataSourceControllerUpdateByIdPath = '/data-sources/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: DataSourcePartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: DataSourcePartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataSourceControllerFind
   */
  static readonly DataSourceControllerFindPath = '/data-sources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<DataSourceWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataSourceWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<DataSourceWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataSourceWithRelations>>) => r.body as Array<DataSourceWithRelations>)
    );
  }

  /**
   * Path part for operation dataSourceControllerCreate
   */
  static readonly DataSourceControllerCreatePath = '/data-sources';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewDataSource
  }): Observable<StrictHttpResponse<DataSource>> {

    const rb = new RequestBuilder(this.rootUrl, DataSourceControllerService.DataSourceControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataSource>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewDataSource
  }): Observable<DataSource> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataSource>) => r.body as DataSource)
    );
  }

}
